__turbopack_context__.v({
  "container": "DVTIpG_container",
  "content": "DVTIpG_content",
  "footer": "DVTIpG_footer",
  "summary": "DVTIpG_summary",
  "summaryHeader": "DVTIpG_summaryHeader",
  "summaryNote": "DVTIpG_summaryNote",
});
